import {collection, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../sellable/controls/sellable-report-selection-control.component";
import {PriceLevelReportSelectionData} from "../../../pricing/price-level/controls/price-level-report-selection-control.component";


export class ProductPriceLevelReportData extends LocalisableEntityData<ProductPriceLevelReportData> {
    @collection(PriceLevelReportSelectionData) priceLevels: PriceLevelReportSelectionData[];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
